'use client'
import { registerUrl } from '@/constants/api';
import { list } from '@/constants/common';
import { Button, Col, Image, Row } from 'antd';
import _ from 'lodash';
import styles from './index.module.scss';
export default function CommonBanner({
  bannerId,
  activeIndex,
}: {
  bannerId: string;
  activeIndex?: string;
}) {
  function clickFn() {
    if (list[bannerId].btnLink) {
      location.href = list[bannerId].btnLink;
    } else {
      location.href = registerUrl;
    }
  }
  const imgPc = _.get(
    list[bannerId],
    ['imgList', `${activeIndex}`],
    list[bannerId].imgUrl
  );
  const imgMoblie = _.get(
    list[bannerId],
    ['imgListMoblie', `${activeIndex}`],
    list[bannerId].imgMobileUrl
  );
  return (
   <div className={styles.bannerWrapper}>
     <div
      className={
        styles.bannerBox + ' mediaBanner ' + styles[list[bannerId].bgClass]
      }
    >
      <Image src={imgPc} preview={false} wrapperClassName="pcImg" />
      <Image
        src={imgMoblie ? imgMoblie : imgPc}
        preview={false}
        wrapperClassName="mobileImg"
      />
      <div className={styles.box + ' box'}>
        <Row align={'middle'} className="bannerGlobal">
          <Col span={list[bannerId].rightImg ? 14 : 24}>
            <div className={styles.title + ' title'}>
              {_.isArray(list[bannerId].title) ? (
                <div className={styles.tit + ' tit'}>
                  {list[bannerId].title.map((t: string, i: number) => {
                    return <p key={i}>{t}</p>;
                  })}
                </div>
              ) : (
                <div className={styles.tit + ' tit'}>
                  {list[bannerId].title}
                </div>
              )}
              {_.get(list[bannerId], 'tipList', []).map(
                (t: string, i: number) => {
                  return (
                    <div className={styles.tip + ' tip'} key={i}>
                      {t}
                    </div>
                  );
                }
              )}
              {list[bannerId].buttonText && (
                <Button className={styles.btn + ' btn'} onClick={clickFn}>
                  {list[bannerId].buttonText}
                  <span> {`>`} </span>
                </Button>
              )}
            </div>
          </Col>
          {list[bannerId].rightImg && (
            <Col span={10}>
              <img
                src={list[bannerId].rightImg}
                className={styles.rightImg + ' rightImg'}
                {..._.get(list[bannerId], 'rightImgStyle', {})}
              />
            </Col>
          )}
        </Row>
      </div>
    </div>
   </div>
  );
}
